import { forwardRef, type InputHTMLAttributes } from 'react';
import clsx from 'clsx';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={clsx(
        'block w-full h-10 px-3 rounded-md',
        'bg-bg-1 text-fg placeholder:text-fg-muted',
        'border transition-colors duration-fast',
        invalid
          ? 'border-danger focus:border-danger'
          : 'border-border focus:border-accent',
        'focus:outline-none',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={clsx(
        'block w-full h-10 px-3 rounded-md',
        'bg-bg-1 text-fg',
        'border transition-colors duration-fast',
        invalid ? 'border-danger' : 'border-border focus:border-accent',
        'focus:outline-none',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});

export function Label({
  htmlFor,
  children,
  className,
  required,
}: {
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
  required?: boolean;
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx('block text-sm text-fg-1 mb-1.5', className)}
    >
      {children}
      {required && <span className="text-danger ml-0.5">*</span>}
    </label>
  );
}

export function FieldError({ children }: { children?: React.ReactNode }) {
  if (!children) return null;
  return <p className="mt-1 text-xs text-danger">{children}</p>;
}
